// extracted by mini-css-extract-plugin
export var container = "index-module--container--2GuoF";
export var dividerNoMobile = "index-module--dividerNoMobile--MrD8y";
export var imageGallery = "index-module--imageGallery--0VEDc";
export var imageGalleryContainer = "index-module--imageGalleryContainer--2AHls";
export var nameAndLocation = "index-module--nameAndLocation--RB4Io";
export var overlay = "index-module--overlay--pb3Jg";
export var projectInfo = "index-module--projectInfo--CVCL8";
export var responsibleCompanies = "index-module--responsibleCompanies--yc88n";